import React, { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Header } from '../../components/layout/header';
import { Footer } from '../../components/layout/footer';
import { SupportForm } from './support-form';
import { ROUTE_PATH } from '../../routes/route-paths';
import Toast from '../../components/common/pop-up-message';

export const SupportPage: React.FC = () => {
  const navigate = useHistory();
  const search = useLocation().search;

  const { callReport, callId, option, contactUs } = useMemo(() => {
    const urlSearchParams = new URLSearchParams(search);

    return {
      callReport: urlSearchParams.get('call-report'),
      callId: urlSearchParams.get('call_id'),
      option: urlSearchParams.get('option'),
      contactUs: urlSearchParams.get('error'),
    };
  }, [search]);

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Header />
      <div className="flex-1">
        <div className="max-w-page mx-auto mt-[76px] px-6 py-8 md:py-12">
          <div className="mb-6 md:mb-8">
            <h1 className="font-albert-sans mb-4 text-2xl font-semibold leading-[30px] tracking-[-0.2px] text-black md:text-[32px] md:leading-[42px] md:tracking-[-0.32px]">
              Feedback & Technical Support
            </h1>
            <p className="font-['Open_Sans'] text-base font-normal leading-6 text-gray-700">
              Have an issue, suggestion, or something not working quite right? Share the details below.
            </p>
          </div>

          <SupportForm
            option={option}
            callReport={callReport}
            callId={callId}
            contactUs={contactUs}
            bottomActionButton={({ isDirty, isSubmitting }) => (
              <div className="mt-8 flex justify-center md:justify-start">
                <button
                  className="bg-button-primary hover:bg-button-primary-hover w-full rounded-full px-8 py-3 font-['Open_Sans'] text-base font-medium leading-5 text-white transition-colors disabled:cursor-not-allowed disabled:bg-gray-300 md:w-auto"
                  type="submit"
                  disabled={!isDirty || isSubmitting}
                >
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            )}
            onSuccessSubmitted={() => {
              Toast.success('Your support request has been successfully submitted', undefined);
              navigate.push(ROUTE_PATH.HOME);
            }}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};
